import { ClientDataCanvas } from "./client_data_canvas/client_data_canvas";

let client = new ClientDataCanvas();
